import Service, { service } from '@ember/service'
import { Tracker } from 'customer-flows/services/trackers/tracker'
import MixpanelTracker from 'customer-flows/services/trackers/mixpanel-tracker'
import MarketingTracker from 'customer-flows/services/trackers/marketing-tracker'
import PosthogTracker from 'customer-flows/services/trackers/posthog'

export default class EventTrackerService extends Service implements EventTracker {
  @service('trackers/mixpanel-tracker') mixpanel: MixpanelTracker
  @service('trackers/marketing-tracker') marketing: MarketingTracker
  @service('trackers/posthog') posthog: PosthogTracker

  private trackers: Tracker[]
  private firedOnceEvents = new Set<string>()

  constructor() {
    super(...arguments)

    this.trackers = [this.mixpanel, this.marketing, this.posthog]
    this.trackers.forEach((tracker) => tracker.setup())
  }

  track<E extends TrackingEventName>(event: E, props?: EventProps<E>): void {
    this.trackers.forEach((tracker) => {
      if (tracker.isEnabled && tracker.handles(event)) {
        tracker.track(event, props)
      }
    })
  }

  trackOnce<E extends TrackingEventName>(event: E, props?: EventProps<E>): void {
    if (this.firedOnceEvents.has(event)) return
    this.firedOnceEvents.add(event)
    this.track(event, props)
  }
}
